<template>
    <el-dialog title="已入库产品信息" :visible.sync="inProductDetailDialog" width="800px" :before-close="handleDialogClose"  append-to-body :close-on-click-modal="false" class="custom-form-dialog custom-height-dialog custom-inventory-dialog">
        <div class="in_product_detail_wrap" v-loading="loading">
            <el-table class="custom_table" :data="formData.log_products" border ref="table" row-key="id" >
                <el-table-column label="产品名称" prop="name" show-overflow-tooltip width="240px"></el-table-column>
                <el-table-column label="入库数量\产品编码" prop="total_num" align="right" show-overflow-tooltip width="230px">
                    <template slot-scope="{row}">
                        <div class="change_code flex_js_wrap">
                            <span>
                                <el-popover  placement="bottom"  popper-class="product_code_popper" title=""  width="226"  trigger="click" v-if="row.code_num">
                                    <span class="change_code_wrap" slot="reference" >
                                       <span>编码明细</span>
                                    </span>
                                    <div class="product_code_wrap">
                                        <ul>
                                            <li class="ellipsis" v-for="item in row.details" v-text="item.code"></li>
                                        </ul>
                                        <div class="code_num_wrap">
                                            共：{{row.code_num}}条
                                        </div>
                                    </div>
                                </el-popover>
                                <span v-if="row.code_num && row.no_code_num" class="line"></span>
                                <span v-if="row.no_code_num" v-text="row.no_code_num"></span>
                            </span>
                            <span class="total_num" >
                               共 <span v-text="row.total_num"></span>
                            </span>

                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="产品单价" prop="cost_price" align="right" show-overflow-tooltip ></el-table-column>
                <el-table-column label="入库仓库" prop="stocks" show-overflow-tooltip width="186px">
                    <template slot-scope="{row}">
                        <span v-text="row.stocks ? row.stocks.name :''"></span>
                    </template>
                </el-table-column>
            </el-table>

            <div class="in_product_detail_field">
                <div class="in_product_detail_field_name">附件</div>
                <div class="in_product_detail_field_value">
                    <div class="upload_file_list_detail" v-if="formData.files.length>0">
                        <div class="upload_file_item" v-for="item in formData.files">
                            <div class="file_left_wrap">
                                <img alt="" src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png" class="file_img">
                            </div>
                            <div class="file_info_wrap">
                                <p class="ellipsis" v-text="item.file_name"></p>
                                <span v-text="item.file_size"></span>
                            </div>
                            <div class="file_right_wrap">
                                <el-tooltip content="预览" effect="dark" placement="top">
                                     <span class="handle_icon_wrap"   @click="handleClickPreview(item)">
                                        <i class="iconfont icon-yanjing"></i>
                                    </span>
                                </el-tooltip>
                                <el-tooltip content="下载" effect="dark" placement="top">
                                <span class="handle_icon_wrap" @click="handleClickDownloadFile(item)">
                                    <i class="iconfont icon-daochu"></i>
                                </span>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                    <div class="upload_file_list_detail" v-else>
                        <div class=" ">--</div>
                    </div>

                </div>
                <div class="in_product_detail_field_name">备注信息</div>
                <div class="in_product_detail_field_value">
                    <div class="note" v-if="formData.note" v-text="formData.note"></div>
                    <div class=" " v-else>--</div>
                </div>

            </div>
            <el-image :preview-src-list="currentList" :src="currentUrl" class="my-img" ref="myImg" style="display: none"></el-image>
        </div>
    </el-dialog>
</template>
<script>
import { stockLogDetail } from "@/api/index.js"
import {pagination} from '@/mixins'
import {getOSSData, uploadImg} from "@/utils/uploadOss";
export default {
    name: "in_product_detail",
    props: {
        inProductDetailDialog: {
            type: Boolean,
            default: false
        },
        inColumnId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading:false,
            formData:{
                log_products:[],
                files:[],
                note:'',
            },
            currentList:[],
            currentUrl:''
        }
    },
    mixins: [pagination],
    created() {
        if(this.inColumnId){
            this.getDetails()
        }
    },
    methods: {
        getDetails(){
            this.loading = true
            stockLogDetail({id:this.inColumnId}).then(res => {
                if(res.code == 200){
                    let { log_products, files, note} = res.data
                    this.formData = {
                        log_products,
                        files,
                        note,
                    }
                }
                this.loading = false
            })
        },
        //点击预览
        handleClickPreview(file) {
            if (file.file_type && file.file_type.indexOf("image") > -1) {
                this.$refs.myImg.showViewer = true;
                this.currentList = [file.file_path];
                this.currentUrl = file.file_path;
            } else {
                if (file.file_type && file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //点击下载附件
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        handleDialogClose() {
            this.$emit("update:inProductDetailDialog", false)
        },
    }
}
</script>
<style  lang="scss" scoped>
@import "@/styles/inventory_management.scss";
</style>